import { useIntl } from 'react-intl'

import { JobDetailsBody, JobDetailsContainer } from './styles'
import JobDetailsLocation from './JobDetailsLocation'
import JobDetailsContact from './JobDetailsContact'
import { H4 } from 'components/Typography'
import { jobInfoMessages } from '../messages'

function JobInfoDetails() {
  const { formatMessage } = useIntl()

  return (
    <JobDetailsContainer>
      <H4>{formatMessage(jobInfoMessages.jobDetailsTitle)}</H4>
      <JobDetailsBody>
        <JobDetailsContact />
        <JobDetailsLocation />
      </JobDetailsBody>
    </JobDetailsContainer>
  )
}

export default JobInfoDetails
